import React from 'react';
import { ContentCard } from '@dopomogai/ui';

export function InvestHowItWorks() {
  const items = [
    { title: 'Buy units', text: 'Each unit represents a share of this round. Units are non-transferable.' },
    { title: 'Agents earn', text: 'The agent generates credits from usage and partnerships.' },
    { title: 'Payouts', text: 'After costs, profits can be distributed to co-owners periodically.' },
  ];
  return (
    <section className="max-w-6xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-6">
      {items.map((it, i) => (
        <ContentCard key={i} title={it.title} text={it.text} index={i} />
      ))}
    </section>
  );
}


